<template>
  <transition name="fade">
    <div v-show="visible" class="modal-img">
      <div class="modal-head">
        <div class="modal-title">
          <slot name="title">{{ title || '鼠害监测' }}</slot>
        </div>

        <div class="modal-control">
          <slot name="tools"></slot>
          <i class="el-icon-close" @click="close"></i>
        </div>
      </div>

      <div class="modal-content" ref="wrap">
        <div v-if="Boolean(msg)" class="text-error">
          {{ msg }}
        </div>

        <div v-show="!msg" class="model-img-container">
          <video
            ref="video"
            :width="width"
            :height="height"
            controls
            muted
            preload="auto"
          >
            <source :src="img.video" type="video/mp4" />
            您的浏览器不支持Video标签。
          </video>

          <slot name="mask"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalPic',
  props: {
    img: Object,
    title: String
  },
  data() {
    return {
      msg: null,
      visible: false,
      width: 600,
      height: 400
    }
  },
  computed: {
    isIE() {
      //取得浏览器的userAgent字符串
      const userAgent = navigator.userAgent
      //判断是否IE浏览器
      return (
        userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
      )
    }
  },
  mounted() {
    this.visible = true
    // 按 Esc 键退出
    window.addEventListener('keyup', this.keyListener)
  },
  methods: {
    close() {
      this.$refs.video.pause()
      this.visible = false
      window.removeEventListener('keyup', this.keyListener)
      this.$nextTick(function () {
        if (typeof this.onClose === 'function') {
          this.onClose()
        }
      })
    },
    keyListener(evt) {
      // 按键 ESC
      if (evt.keyCode === 27) {
        this.close()
      }
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.$nextTick(() => {
          this.height = this.$refs.wrap.clientHeight
          this.width = this.$refs.wrap.clientWidth
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-img {
  position: absolute;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 2004;
  .modal-head {
    display: flex;
    justify-content: space-between;
    height: 60px;
    padding: 0 40px;
    background-color: rgb(10, 10, 10);
    .modal-control {
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        cursor: pointer;
        line-height: 60px;
        font-size: 1.5rem;
        &:not(:first-child) {
          margin-left: 1rem;
        }
      }
    }
    .modal-title,
    .modal-subtitle {
      font-size: 1.5rem;
      color: #fff;
      line-height: 60px;
    }
  }
  .modal-content {
    width: 100%;
    height: 100%;
    max-height: calc(100vh - 60px);
    background-color: rgba(10, 10, 10, 0.92);
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 40%;
    }
    .modal-button {
      z-index: 3;
      position: absolute;
      width: 4rem;
      height: 4rem;
      font-size: 2rem;
      color: #fff;
      background-color: transparent;
      border-width: 2px;
      &:active {
        background-color: #606266;
      }
      &:hover {
        color: #409eff;
      }
      &.prev {
        left: 2%;
        top: 50%;
      }
      &.next {
        right: 2%;
        top: 50%;
      }
    }
    .modal-button.is-disabled {
      &:active {
        background-color: transparent;
      }
      &:hover {
        color: #fff;
      }
    }
    .model-img-container {
      z-index: 2;
      position: relative;
      user-select: none;
      transition: transform 0.2s ease;
    }
  }
}
</style>
